import { fetchOpgavekompleksetTasks } from '../../api/request.fetch-opgavekomplekset-tasks.js';

async function postProcessOpgavekompleksetData(data) {
  const {
    descriptors,
    ...processedData
  } = shuffleTasksIfNecessary(structuredClone(data));
  const tasks = await fetchOpgavekompleksetTasks(descriptors);
  return {
    ...processedData,
    tasks: addDescriptorMetadataToTasks(tasks, data)
  };
}
function addDescriptorMetadataToTasks(tasks, data) {
  const flattenedDescriptors = data.descriptors.flatMap(it => it.type === "stack" ? it.tasks : it.type === "folder" ? [] : [it]);
  const tasksWithMetadata = tasks.map(task => {
    const relatedDescriptor = flattenedDescriptors.find(it => it.id === task.id);
    return {
      ...task,
      conditions: relatedDescriptor?.conditions ?? null,
      hints: relatedDescriptor?.hints ?? []
    };
  });
  const output = [];
  for (const task of tasksWithMetadata) {
    const relatedStackIndex = data.descriptors.findIndex(descriptor => descriptor.type === "stack" && descriptor.tasks.length > 1 && descriptor.tasks.some(it => it.id === task.id));
    const relatedStack = data.descriptors[relatedStackIndex];
    if (relatedStackIndex === -1) {
      output.push({
        ...task,
        type: "task"
      });
    } else {
      const currentStack = (() => {
        const lastItem = output.at(-1);
        if (lastItem?.type === "stack" && lastItem.id === `stack-${relatedStackIndex}`) {
          return lastItem;
        } else {
          const stack = {
            type: "stack",
            id: `stack-${relatedStackIndex}`,
            title: relatedStack?.type === "stack" ? relatedStack.title : "",
            tasks: []
          };
          output.push(stack);
          return stack;
        }
      })();
      currentStack.tasks.push(task);
    }
  }
  return output;
}
function shuffleTasksIfNecessary(data) {
  const shouldRandomize = data.settings.flowType.endsWith("-random");
  if (!shouldRandomize) {
    return data;
  }
  shuffleArray(data.descriptors);
  return data;
}

// See https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const a = array[i];
    const b = array[j];
    if (!a || !b) {
      continue;
    }
    [array[i], array[j]] = [b, a];
  }
}

export { postProcessOpgavekompleksetData };
//# sourceMappingURL=processor.post-data.js.map
